export default function MobilePlayer({x=600, y=900}){
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-miterlimit="10"
        clip-rule="evenodd"
        viewBox={`0 0 ${x} ${y}`}
    >
        <g>
            <path
                fill="#EBF0F3"
                fill-rule="nonzero"
                d="M1.4 0.9H537V345.4H1.4z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.12024 0 0 2.90276 -1.568 -2.612)"
            ></path>
            <path
                fill="#2F3035"
                fill-rule="nonzero"
                d="M1.4 1.3H537V302.6H1.4z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.11277 0 0 3.06081 .442 -2.868)"
            ></path>
            <path
                fill="#58585A"
                fill-rule="nonzero"
                d="M118.1 327.4c0 .4.3.7.7.7h252c.4 0 .7-.3.7-.7v-5.8c0-.4-.3-.7-.7-.7h-252c-.4 0-.7.3-.7.7v5.8z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507) matrix(.58375 0 0 1 49.159 0)"
            ></path>
            <path
                fill="#E71F29"
                fill-rule="nonzero"
                d="M118 327.4c0 .4.3.7.7.7h40c.4 0 .7-.3.7-.7v-5.8c0-.4-.3-.7-.7-.7h-40c-.4 0-.7.3-.7.7v5.8z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507)"
            ></path>
            <path
                fill="#767678"
                fill-rule="nonzero"
                d="M130.2 324.3c0-3.676-3.024-6.7-6.7-6.7s-6.7 3.024-6.7 6.7 3.024 6.7 6.7 6.7 6.7-3.024 6.7-6.7z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507)"
            ></path>
            <path
                fill="#FDFDFF"
                fill-rule="nonzero"
                d="M129.6 323.8c0-3.676-3.024-6.7-6.7-6.7s-6.7 3.024-6.7 6.7 3.024 6.7 6.7 6.7 6.7-3.024 6.7-6.7z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507)"
            ></path>
            <path
                fill="#BABEC1"
                fill-rule="nonzero"
                d="M497.3 322.4l-.8-1.4.7-3.5-2-1.2-2.7 2.4H491l-2.7-2.4-2 1.2.7 3.5-.8 1.4-3.4 1.1v2.3l3.4 1.1.8 1.4-.7 3.5 2 1.2 2.7-2.4h1.6l2.7 2.4 2-1.2-.7-3.5.8-1.4 3.4-1.1v-2.3l-3.5-1.1zm-5.5 5.2c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9zm18.9-4.3v-4.9c0-.4.3-.8.8-.8h4.9v-2h-4.9c-1.5 0-2.8 1.2-2.8 2.8v4.9h2zm8.5-5.7h4.9c.4 0 .8.3.8.8v4.9h2v-4.9c0-1.5-1.2-2.8-2.8-2.8h-4.9v2zm-2.9 14.2h-4.9c-.4 0-.8-.3-.8-.8v-4.9h-2v4.9c0 1.5 1.2 2.8 2.8 2.8h4.9v-2zm8.5-5.7v4.9c0 .4-.3.8-.8.8h-4.9v2h4.9c1.5 0 2.8-1.2 2.8-2.8v-4.9h-2z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507) translate(-134.475)"
            ></path>
            <path
                fill="#2F3035"
                fill-rule="nonzero"
                d="M278.644 324.7c0-1 .1-1.8.3-2.5.2-.6.5-1.1.9-1.4.4-.3.9-.5 1.6-.5.5 0 .9.1 1.2.3.3.2.6.5.9.8.2.3.4.8.5 1.3.1.5.2 1.2.2 2 0 1-.1 1.8-.3 2.4-.2.6-.5 1.1-.9 1.4-.4.3-.9.5-1.6.5-.8 0-1.5-.3-2-.9-.5-.6-.8-1.7-.8-3.4zm1.1 0c0 1.4.2 2.3.5 2.8s.7.7 1.2.7.9-.2 1.2-.7c.3-.5.5-1.4.5-2.8s-.2-2.4-.5-2.8c-.3-.5-.7-.7-1.2-.7s-.9.2-1.2.6c-.4.6-.5 1.5-.5 2.9zm6.1-.7v-1.2h1.2v1.2h-1.2zm0 5v-1.2h1.2v1.2h-1.2zm8.3-1v1h-5.7c0-.3 0-.5.1-.7.1-.4.4-.8.7-1.1.3-.4.8-.8 1.4-1.3.9-.8 1.6-1.4 1.9-1.8.3-.4.5-.9.5-1.3s-.1-.8-.4-1.1c-.3-.3-.7-.4-1.2-.4s-.9.2-1.2.5c-.3.3-.5.7-.5 1.3l-1.1-.1c.1-.8.4-1.4.8-1.8.5-.4 1.1-.6 2-.6.8 0 1.5.2 2 .7.5.5.7 1 .7 1.7 0 .3-.1.7-.2 1-.1.3-.4.7-.7 1-.3.4-.9.9-1.6 1.5-.6.5-1 .9-1.2 1.1-.2.2-.3.4-.4.6h4.1v-.2zm1.2-3.3c0-1 .1-1.8.3-2.5.2-.6.5-1.1.9-1.4.4-.3.9-.5 1.6-.5.5 0 .9.1 1.2.3.3.2.6.5.9.8.2.3.4.8.5 1.3.1.5.2 1.2.2 2 0 1-.1 1.8-.3 2.4-.2.6-.5 1.1-.9 1.4-.4.3-.9.5-1.6.5-.8 0-1.5-.3-2-.9-.6-.6-.8-1.7-.8-3.4zm1 0c0 1.4.2 2.3.5 2.8s.7.7 1.2.7.9-.2 1.2-.7c.3-.5.5-1.4.5-2.8s-.2-2.4-.5-2.8c-.3-.5-.7-.7-1.2-.7s-.9.2-1.2.6c-.3.6-.5 1.5-.5 2.9zm8.5 4.4l2.5-8.9h.8l-2.5 8.9h-.8zm11.1-.1h-1.1v-6.7c-.3.2-.6.5-1 .7-.4.2-.8.4-1.1.5v-1c.6-.3 1.1-.6 1.5-1 .4-.4.8-.8.9-1.1h.7v8.6h.1zm2.7-4.3c0-1 .1-1.8.3-2.5.2-.6.5-1.1.9-1.4.4-.3.9-.5 1.6-.5.5 0 .9.1 1.2.3.3.2.6.5.9.8.2.3.4.8.5 1.3.1.5.2 1.2.2 2 0 1-.1 1.8-.3 2.4-.2.6-.5 1.1-.9 1.4-.4.3-.9.5-1.6.5-.8 0-1.5-.3-2-.9-.5-.6-.8-1.7-.8-3.4zm1.1 0c0 1.4.2 2.3.5 2.8s.7.7 1.2.7.9-.2 1.2-.7c.3-.5.5-1.4.5-2.8s-.2-2.4-.5-2.8c-.3-.5-.7-.7-1.2-.7s-.9.2-1.2.6c-.3.6-.5 1.5-.5 2.9zm6.2-.7v-1.2h1.2v1.2h-1.2zm0 5v-1.2h1.2v1.2h-1.2zm2.7-2.3l1.1-.1c.1.6.3 1 .6 1.3.3.3.6.4 1.1.4.5 0 .9-.2 1.3-.5.3-.3.5-.8.5-1.3s-.2-.9-.5-1.2c-.3-.3-.7-.5-1.2-.5-.2 0-.4 0-.7.1l.1-.9h.2c.4 0 .9-.1 1.2-.4.4-.2.5-.6.5-1.1 0-.4-.1-.7-.4-1-.3-.3-.6-.4-1-.4s-.8.1-1 .4c-.3.3-.4.6-.5 1.2l-1.1-.2c.1-.7.4-1.3.9-1.6.5-.4 1-.6 1.7-.6.5 0 .9.1 1.3.3.4.2.7.5.9.8.2.3.3.7.3 1.1 0 .4-.1.7-.3 1-.2.3-.5.5-.9.7.5.1.9.4 1.2.7.3.4.4.8.4 1.4 0 .8-.3 1.4-.8 1.9s-1.2.8-2.1.8c-.8 0-1.4-.2-1.9-.7-.5-.3-.8-.9-.9-1.6zm6.7-2c0-1 .1-1.8.3-2.5.2-.6.5-1.1.9-1.4.4-.3.9-.5 1.6-.5.5 0 .9.1 1.2.3.3.2.6.5.9.8.2.3.4.8.5 1.3.1.5.2 1.2.2 2 0 1-.1 1.8-.3 2.4-.2.6-.5 1.1-.9 1.4-.4.3-.9.5-1.6.5-.8 0-1.5-.3-2-.9-.5-.6-.8-1.7-.8-3.4zm1.1 0c0 1.4.2 2.3.5 2.8s.7.7 1.2.7.9-.2 1.2-.7c.3-.5.5-1.4.5-2.8s-.2-2.4-.5-2.8c-.3-.5-.7-.7-1.2-.7s-.9.2-1.2.6c-.4.6-.5 1.5-.5 2.9zM86.3 320.6h3.3v8.5h-3.3v-8.5zm4.5 8.5l5.2 4.4v-17.3l-5.2 4.4v8.5zm10.1-8.2c.4-.4 1-.4 1.4 0 1.9 1.9 1.9 4.9 0 6.8-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4 1.1-1.1 1.1-2.8 0-3.9-.4-.5-.4-1.1 0-1.5zm6.2-4.8c.4-.4 1-.4 1.4 0 4.5 4.5 4.5 11.7 0 16.2-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4 3.7-3.7 3.7-9.6 0-13.3-.4-.4-.4-1.1 0-1.5z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507)"
            ></path>
            <path
                fill="#2F3035"
                fill-rule="nonzero"
                d="M104 318.4c.4-.4 1-.4 1.4 0 3.2 3.2 3.2 8.4 0 11.5-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4 2.4-2.4 2.4-6.3 0-8.7-.4-.3-.4-1 0-1.4zm-87.4 14.9c-.8-.6-.8-1.6-.8-1.6v-14.1s0-1.1.9-1.7c1.1-.7 2-.1 2-.1l13 7s1 .5 1 1.7-1 1.7-1 1.7l-13 7c0 .3-1 .9-2.1.1zm53.7-1.8c0 .4-.3.7-.7.7h-1.9c-.4 0-.7-.3-.7-.7V318c0-.4.3-.7.7-.7h1.9c.4 0 .7.3.7.7v13.5zm-19.6.2c-.6-.5-.7-1.3-.7-1.3V319s0-.9.7-1.3c.9-.6 1.6-.1 1.6-.1l10.6 5.7s.8.4.8 1.4c0 1-.8 1.4-.8 1.4l-10.6 5.7c.1 0-.7.5-1.6-.1z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507)"
            ></path>
            <path
                fill="#E71F29"
                fill-rule="nonzero"
                d="M454.3 330.1v-10.7h2.2v4.2h4.2v-4.2h2.2v10.7h-2.2v-4.7h-4.2v4.7h-2.2zm10.9-10.8h4c.9 0 1.6.1 2 .2.6.2 1.2.5 1.6 1 .4.5.8 1.1 1 1.7.2.7.4 1.5.4 2.5 0 .9-.1 1.6-.3 2.3-.3.8-.7 1.4-1.1 1.9-.4.4-.9.7-1.5.9-.5.2-1.1.2-1.9.2h-4.1v-10.7h-.1zm2.1 1.8v7.1h1.6c.6 0 1 0 1.3-.1.4-.1.6-.2.9-.4.2-.2.4-.6.6-1 .1-.5.2-1.1.2-2 0-.9-.1-1.5-.2-1.9-.1-.4-.4-.8-.6-1-.3-.2-.6-.4-1-.5-.3-.1-.9-.1-1.8-.1h-1v-.1z"
                transform="matrix(1 0 0 .9 0 0) matrix(1.43848 0 0 1.59831 -12.907 444.507) translate(-55.807)"
            ></path>
        </g>
        <g  className="play-btn"
            transform="translate(300 416) scale(1.00626) translate(-58.35 -58.65)"
        >
            <clipPath id="_clip1">
                <path d="M0 0H116.7V117.3H0z"></path>
            </clipPath>
            <g
                stroke="#E1E2E6"
                clip-path="url(#_clip1)"
                className="play_btn"
            >
                <circle
                    cx="57.8"
                    cy="57.8"
                    r="54.9"
                    fill="#2F3035"
                    stroke-width="4"
                ></circle>
                <path
                    fill="#DFE0E4"
                    fill-rule="nonzero"
                    stroke-width="1"
                    d="M36.9 86.9V28.8l53.7 29-53.7 29.1z"
                ></path>
            </g>
        </g>
    </svg>
}